import { render } from "./Unregister.vue?vue&type=template&id=b984a36c"
import script from "./Unregister.vue?vue&type=script&lang=js"
export * from "./Unregister.vue?vue&type=script&lang=js"

import "./Unregister.vue?vue&type=style&index=0&id=b984a36c&lang=css"

import exportComponent from "D:\\Nomura\\PROJECT\\010.Src_By_SYSLAB\\007.MCSC_Web\\Git_main\\FrontEnd\\site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__